module.exports = __webpack_public_path__ + "img/aParty_111223_E.0ed38103.jpg";